import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTemp = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M10 11.2787V3.5C10 2.96957 9.78929 2.46086 9.41421 2.08579C9.03914 1.71071 8.53043 1.5 8 1.5C7.46957 1.5 6.96086 1.71071 6.58579 2.08579C6.21071 2.46086 6 2.96957 6 3.5V11.2787C5.54714 11.6837 5.22794 12.2167 5.08464 12.8072C4.94134 13.3976 4.98069 14.0176 5.19748 14.5852C5.41428 15.1528 5.7983 15.6412 6.29874 15.9857C6.79917 16.3303 7.39243 16.5147 8 16.5147C8.60758 16.5147 9.20083 16.3303 9.70126 15.9857C10.2017 15.6412 10.5857 15.1528 10.8025 14.5852C11.0193 14.0176 11.0587 13.3976 10.9154 12.8072C10.7721 12.2167 10.4529 11.6837 10 11.2787Z",
			stroke: "#ADB3C4",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12 6.5H13",
			stroke: "#ADB3C4",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12 9.5H13",
			stroke: "#ADB3C4",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
const ForwardRef = forwardRef(SvgTemp);
export default ForwardRef;
